import { routes } from '@sketch/constants'
import { Link } from '@sketch/components'
import React from 'react'

import { Banner } from './PublicViewHiddenProfileBanner.styles'

interface PublicViewHiddenProfileBannerProps {
  workspaceId: string
  rounded?: boolean
}

export const PublicViewHiddenProfileBanner = (
  props: PublicViewHiddenProfileBannerProps
) => {
  const { workspaceId, rounded } = props
  return (
    <Banner type="neutral" size="tiny" rounded={rounded}>
      Your public profile is currently hidden — only you and other Admins can
      see it. To publish, head over to{' '}
      <Link
        variant="secondary"
        to={{
          pathname: routes.WORKSPACE_SETTINGS_PROFILE.create({ workspaceId }),
        }}
      >
        Profile Settings
      </Link>
      .
    </Banner>
  )
}
